module.exports = __webpack_public_path__ + "static/media/Project1Board.b1d20e99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/Project1Board.jpg
// module id = 209
// module chunks = 0